module.exports = {
      id: "logos:nswvolunteering-cobrand-usage",
      viewBox: "0 0 178.1 106.1",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#logos:nswvolunteering-cobrand-usage",
      toString: function () {
        return this.url;
      }
    }